// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zr_I","content":"styles_content__326ap","tableWrap":"styles_tableWrap__2Wp7o"};